module.exports = __webpack_public_path__ + "static/laser_hero-e0147b2e3f22d3ee04640061c845a8d1.svg";